<template>
  <div class="page container">
    <div class="container">
      <div class="column">
        <div class="content">
          <h3>Grupo de Estudos</h3>
          <p>Mensalmente estudiosos do pensamento do psicanalista inglês Donald W. Winnicott se reúnem para se debruçar sobre um texto específico desse autor e buscar ampliações para a compreensão de situações clínica e contemporâneas diversas.</p>
        </div>
        <h3 class="is-size-4"></h3>
        <p class=""></p>
        
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'QuemSomos',
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .page{
    text-align: left
  }
  .container{
    max-width: 800px;
  }
</style>
